import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { useBrand } from "@/context/SiteContext";

export default function NotFound() {
  const brand = useBrand();
  useSeo({ title: `Page Not Found | ${brand.name}`, description: "The page you are looking for could not be found." });
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
      <div className="font-display text-7xl font-black text-gradient">404</div>
      <h1 className="font-display text-2xl font-bold text-white mt-4">Page Not Found</h1>
      <p className="text-slate-400 mt-2">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="btn-primary mt-6" data-testid="notfound-home-button"><Home size={16} /> Back to Home</Link>
    </div>
  );
}
